<template>
  <div class="discussion-message" :class="positionClass">
    <span><slot></slot></span>
    <div  class="text-right" v-if="value.attachment">
      <b-button @click="openFile" :title="$t('_openAttachment')" v-b-tooltip.hover  class="bg-light">
        <fa fa-class="file-download" />
      </b-button>
    </div>
    <div class="footer">
      <div>
        {{ this.$t('message.sentAtBy', { date: formatDateTime(date), sender: sender}) }}
      </div>
    </div>
  </div>
</template>

<script>
import CommonApi from '@/api/commonApi'
import formatter from '@/components/global/mixins/formatterMethods'
import fa from '@/components/global/icon/fontAwesome'

const api = new CommonApi()

export default {
  components: {
    fa
  },

  mixins: [formatter],

  props:{
    value: {
      type: Object,
      required: true
    },
    isBackOffice: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      date: null,
      bbaContact: null,
      user: null,
      isReceived: false
    }
  },

  created () {
    this.date = this.value.date
    this.setUsers()
    this.setIsReceived()
  },

  methods: {
    setUsers () {
      if (this.value.bba_contact !== undefined) {
        this.bbaContact = {
          first_name: this.value.bba_contact.firstname,
          last_name: this.value.bba_contact.name
        }
      } else {
        this.user = this.value.user
      }
    },

    setIsReceived () {
      this.isReceived = this.isBackOffice === !this.bbaContact
    },

    openFile () {
      window.open(api.downloadMessageAttachment(this.value.id), '_blank')
    }
  },

  computed: {
    sender () {
      return this.value.is_from_reader
        ? this.$t('_you')
        : this.fullName(this.bbaContact || this.user, false, this.bbaContact !== null)
    },

    positionClass () {
      //return this.bbaContact === null ? 'discussion-user' : 'discussion-bba'
      return this.isReceived ? 'right' : 'left'
    }
  }
}
</script>

<style lang="scss">
  .discussion-message {
    // width: 60%;
    // display: block;
    // color: white;
    //
    // &.left {
    //   background-color: darkblue;
    // }
    //
    // &.right {
    //   margin-left: auto;
    //   background-color: orange;
    //   right: 0;
    // }

    // .footer {
    //   position: relative !important;
    // }
  }
</style>
